<template>
  <div />
</template>

<script>
export default {

  name: 'MatrixVariationItem',

  props: {
    supressWarnings: {
      type: Boolean,
      default: true
    },
    selectAttributeParent: {
      type: Function
    },
    variations: {
      type: Array
    },
    selectedAttributes: {
      type: Object
    },
    mergeAttributes: {
      type: Array
    }
  },

  data () {
    return {
      qty: 0
    };
  },

  computed: {
    attrVariation () {
      if (!this.variations.length) {
        return null;
      }

      const mergeAttributesConverted = {};

      this.mergeAttributes.forEach(attribute => {
        mergeAttributesConverted[attribute.key] = attribute.val;
      });

      const mergedAttributes = {
        ...this.selectedAttributes,
        ...mergeAttributesConverted
      };

      const variationItem = this.variations.find(variation => {
        let matched = true;

        if (!variation.attributes.length) {
          matched = false;
        }
        variation.attributes.forEach(attribute => {
          if (!mergedAttributes.hasOwnProperty(attribute.attributeId) || mergedAttributes[attribute.attributeId] != attribute.attributeValueId) {
            matched = false;
          }
        });
        return matched;
      });

      if (variationItem && variationItem.variationId) {
        variationItem.variationId = parseInt(variationItem.variationId);
      }

      return variationItem || {};
    },

    matrixVariationGraduatedPrice () {
      if (!this.attrVariation || !this.attrVariation.variationId) {
        return null;
      }

      const calculatedPrices = this.attrVariation.variationData.prices;
      const graduatedPrices = calculatedPrices.graduatedPrices;

      let returnPrice;

      if (graduatedPrices && graduatedPrices[0]) {
        let quantity = 0;

        if (!this.isBasketItemQuantityUpdate) {
          const variationId = this.attrVariation.variationId;
          const basketItem = this.basketItems.find(item => item.variationId === variationId) || {};

          if (basketItem && basketItem.quantity) {
            quantity = basketItem.quantity;
          }
        }
        quantity += this.qty;
        quantity = (quantity > 0) ? quantity : 1;

        const prices = graduatedPrices.filter(price => {
          return parseFloat(quantity) >= price.minimumOrderQuantity;
        });

        if (prices[0]) {
          returnPrice = prices.reduce((prev, current) => (prev.minimumOrderQuantity > current.minimumOrderQuantity) ? prev : current);
          // returnPrice = returnPrice.unitPrice.value;
        }
      }

      return returnPrice || calculatedPrices.default;
    },

    inBasketQty () {
      const variationId = this.attrVariation.variationId;
      const basketItem = this.basketItems.find(item => item.variationId === variationId) || {};

      let quantity = 0;

      if (basketItem && basketItem.quantity) {
        quantity = basketItem.quantity;
      }

      return quantity;
    },

    basketItems () {
      return this.$store.state.basket.items;
    },

    isBasketItemQuantityUpdate () {
      return this.$store.state.basket.isBasketItemQuantityUpdate;
    }
  },

  methods: {
    selectItem () {
      if (this.attrVariation && this.attrVariation.variationId) {
        const index = App.config.log.data.indexOf('print_warnings');

        if (this.supressWarnings) {
          if (index > -1) {
            App.config.log.data.splice(index, 1);
          }
        }

        this.mergeAttributes.forEach(attribute => {
          this.selectAttributeParent(attribute.key, attribute.val);
        });

        if (this.supressWarnings && index > -1) {
          if (App.config.log.data.indexOf('print_warnings') == -1) {
            App.config.log.data.push('print_warnings');
          }
        }
      }
    },
    updateQuantity (qty) {
      document.dispatchEvent(new CustomEvent('matrixVariationQuantityUpdated', {
        detail: {
          qty: qty,
          variation: this.attrVariation
        }
      }));
      this.qty = qty;
    }
  }
};
</script>
